import { Slider } from '@meitu/saas-ui';
import { type IListStyleMaterial } from '@meitu/saas-editor-core/es/version-types';
import { ColorGroup } from '@meitu/xdesign-widgets';
import LabelAction from '@/components/label-action';
import { LIST_MARKER_SIZE_RANGE } from '@/constants';
import { useLocaleStore } from '@/i18n';
import './controller.less';

type Props = {
    /**
     * 当前选中的列表样式配置
     */
    config: IListStyleMaterial;
    /**
     * 修改缩放值
     * @param value - 缩放值
     */
    onScaleChange: (value: number, options: { writeHistory: boolean }) => void;
    /**
     * 修改颜色
     * @param idx - 颜色索引
     * @param value - 颜色值
     */
    onPieceColorChange: (idx: number, value: string, options: { writeHistory: boolean }) => void;
    /**
     * 修改列表序号颜色
     * @param value - 颜色值
     */
    onListOrderColorChange: (value: string, options: { writeHistory: boolean }) => void;
};

export const Controller: React.FC<Props> = ({ config, onScaleChange, onPieceColorChange, onListOrderColorChange }) => {
    const { $t } = useLocaleStore();

    const { scale, iconColors, autoIncrement, fontColor } = config;
    const hasEditableColor = iconColors.some((item) => item.editable);
    const enableSetListOrderColor = autoIncrement !== 'none' && fontColor;

    return (
        <div className="list-style-ctrl">
            <LabelAction title={$t((v) => v.textListStyle.size)} align>
                <Slider
                    min={LIST_MARKER_SIZE_RANGE.min}
                    max={LIST_MARKER_SIZE_RANGE.max}
                    step={LIST_MARKER_SIZE_RANGE.step}
                    value={scale}
                    onChange={(value) => onScaleChange(value, { writeHistory: false })}
                    onAfterChange={(value) => onScaleChange(value, { writeHistory: true })}
                />
            </LabelAction>

            {hasEditableColor || enableSetListOrderColor ? (
                <LabelAction title={$t((v) => v.textListStyle.color)} align>
                    <div className="list-style-ctrl__colors">
                        {hasEditableColor
                            ? iconColors.map(({ color, editable }, idx) => {
                                  if (!editable) return null;

                                  return (
                                      <div key={`list-marker-color-${idx}`} className="list-style-ctrl__color">
                                          <ColorGroup
                                              hideAlpha
                                              hideEmptyColor
                                              color={color}
                                              setColor={(value) =>
                                                  onPieceColorChange(idx, value, { writeHistory: false })
                                              }
                                              setColorAfter={(value, _, { isBrandColor }) => {
                                                  onPieceColorChange(idx, value, { writeHistory: true });
                                                  if (isBrandColor) {
                                                      window._stat_track?.('hb_layers_func_use', {
                                                          func_id: '9_107',
                                                      });
                                                  }
                                              }}
                                              customPopupTrigger={
                                                  <div
                                                      className="list-style-ctrl__item"
                                                      style={{ backgroundColor: color }}
                                                  />
                                              }
                                              popupOverlayClassName="list-style-ctrl__cg"
                                              onToggleBizTab={(bizTab) => {
                                                  if (bizTab === 'team') {
                                                      window._stat_track?.('hb_layers_func_click', {
                                                          func_id: '9_107',
                                                      });
                                                  }
                                              }}
                                          />
                                      </div>
                                  );
                              })
                            : null}

                        {enableSetListOrderColor ? (
                            <div className="list-style-ctrl__color">
                                <ColorGroup
                                    hideAlpha
                                    hideEmptyColor
                                    color={fontColor}
                                    setColor={(value) => onListOrderColorChange(value, { writeHistory: false })}
                                    setColorAfter={(value, _, { isBrandColor }) => {
                                        onListOrderColorChange(value, { writeHistory: true });
                                        if (isBrandColor) {
                                            window._stat_track?.('hb_layers_func_use', {
                                                func_id: '9_107',
                                            });
                                        }
                                    }}
                                    customPopupTrigger={
                                        <div className="list-style-ctrl__item" style={{ backgroundColor: fontColor }} />
                                    }
                                    popupOverlayClassName="list-style-ctrl__cg"
                                    onToggleBizTab={(bizTab) => {
                                        if (bizTab === 'team') {
                                            window._stat_track?.('hb_layers_func_click', {
                                                func_id: '9_107',
                                            });
                                        }
                                    }}
                                />
                            </div>
                        ) : null}
                    </div>
                </LabelAction>
            ) : null}
        </div>
    );
};
